// import '../core/lockdown'
import { createRoot } from 'react-dom/client'
import { Route, Router, Switch } from 'wouter'

import { Game } from './components/Game'

function Web() {
  return (
    <Router>
      <Switch>
        <Route path='/' component={Game} />
      </Switch>
    </Router>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<Web />)
